import { render, staticRenderFns } from "./CmgTermsAndConditionsModal.vue?vue&type=template&id=995d9a14&scoped=true&lang=pug&"
import script from "./cmg-terms-and-conditions-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-terms-and-conditions-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgTermsAndConditionsModal.vue?vue&type=style&index=0&id=995d9a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995d9a14",
  null
  
)

export default component.exports